<template>
  <div class="task-view">
      <div class="notice">
          <div class="u-btn rule_old" @click="$map_modal();"></div>
          <span>活动期间，和你邀请到的回归老友一起进行游戏，可领取丰厚奖励</span>
          <div class="reflash u-btn" @click="task_reflash()" v-if="login"><em class="icon"></em>刷新</div>
      </div>

      <div class="task-list" v-if="ready">
          <ul v-if="task_info.filter(function(e){return e.config}).length > 0">
              <li v-for="(item,n) in task_info" :key="'t-' + n">
                  <h6><p>{{ item.config.taskName }}</p></h6>
                  <p class="task-content" v-html="item.task_content"></p>
                  <div class="task-pro"><b>{{ item.max_sCh }}</b><span>{{~~item.rate}}/{{ item.max }}</span></div>
                  <ul class="reward-list">
                      <li v-for="(r,index) in item.config.giftList" :key="'r-' + index" v-bind:data-tips="r.giftId">
                          <div class="item" 
                            @click="$item_tips(r.giftId + '_' + r.sendNum)"
                            @mouseover="$tips_on($event,r.giftId + '_' + r.sendNum)"
                            @mouseleave="$tips_off()"                          
                          >
                            <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + r.giftId + '_' + r.sendNum + '.jpg'" v-if="r.sendNum > 1">
                            <img v-bind:src="'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/icon/' + r.giftId + '.jpg'" v-if="r.sendNum == 1">                              
                          </div>
                          <p class="item-name">{{ r.giftName }} <span v-if="r.giftId == 'j001'">* {{ r.sendNum }}</span></p>
                      </li>
                  </ul>
                  <div class="u-btn apply" @click="apply_task(item.no,item,item.isCompleted)" v-if="item.isCompleted && !item.isSubmit"></div>
                  <div class="u-btn apply dismiss" v-else></div>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: 'task-invite-view',
  data () {
    return {
      ready : false,
      task_info : [
          {
              title : '并肩作战*壹',
              task_content : '与回归老友一起组队匹配胜利竞技/出征游戏',
              max_sCh : '一局',
              max : 1,
              reward : ['1','2','3'],
              no : 'z01',
              tid : '5',
              rate : 0,
              isCompleted : false,
              isSubmit : false,
          },
          {
              title : '并肩作战*贰',
              task_content : '与回归老友一起组队匹配胜利竞技/出征游戏',
              max_sCh : '三局',
              max : 3,
              reward : ['1','2','3'],
              no : 'z02',
              tid : '6',
              rate : 0,
              isCompleted : false,
              isSubmit : false,              
          },
          {
              title : '并肩作战*叁',
              task_content : '与回归老友一起组队 匹配胜利竞技/出征游戏（需要已至少成功邀请三人）',
              max_sCh : '七局 ',
              max : 7,
              reward : ['1','2','3'],
              no : 'z03',
              tid : '7',
              rate : 0,
              isCompleted : false,
              isSubmit : false,              
          },                    
      ],
    }
  },
  props : {
    ua : {
        default : ()=>{},
    },
    login : {
        default : 0,
    },      
  },  
  created (){
      if(this.login && this.ua.areaId)this.task_render();
      this.get_task_info();
  },
  methods : {
      task_render (){
          var _this = this;
          
          _this.$axios.get(_this.$global.ajax_url_map.task_info,{
              params: {
                  utype : 0,
                  gid : 2,
              }
          })
          .then(res => {
              if(res.data.code == 0){
                  //TODO
                  if(!res.data.data.length)return;

                  for(var i = 0;i< _this.task_info.length;i++){
                    var temp = res.data.data.filter(function(e){
                        return e.taskNo == _this.task_info[i].no;
                    });

                    _this.task_info[i].isCompleted = temp[0].isCompleted;
                    _this.task_info[i].isSubmit = temp[0].isSubmit;
                    _this.task_info[i].rate = temp[0].rate;
                  }
              }
              else{
                  _this.$toast('任务模块:' + res.data.message);
              }
          });
      },
      apply_task (id,data,finish){

          var _this = this;

          if(!_this.login)return this.$mslogin.open();
          if(!_this.ua.areaId)return this.$bind();

          if(!finish)return this.$toast('任务尚未完成');
          
          _this.$axios.post(_this.$global.ajax_url_map.apply_task_invite,{
              taskno : id,
          })
          .then(res => {
              if(res.data.code == 0){
                  //TODO
                  _this.$toast('领取成功');
                  var ticket = data.config.giftList.filter(function(e){ return e.giftId == 'j001' })[0].sendNum;
                  _this.$score_update(_this.ua.score + parseInt(ticket));

                  data.isSubmit = true;
              }
              else{
                  _this.$toast(res.data.message);
              }
          });
      },
      get_task_info(){
          var _this = this;
          var orderList = ['z01','z02','z03']
          _this.$axios.get(_this.$global.ajax_url_map.task_detail,{
              params: {
                  type : 2,
              }
          })
          .then(res => {
              if(res.data.code == 0){
                  //TODO
                _this.ready = true;

                for(var i = 0; i < orderList.length;i++){
                    var the_config = res.data.data.filter(function(e){ return e.taskNo == orderList[i] })[0]
                    _this.task_info[i].config = the_config;
                }

              }
              else{
                  //_this.$toast('任务信息模块:' + res.data.message);
                  console.log('任务信息模块:' + res.data.message);
              }
          });          
      },
      task_reflash(){
          var _this = this;
          this.$axios.post(_this.$global.ajax_url_map.reflash)
          .then(res => {
              _this.$toast('刷新成功~');
              if(res.data.code == 0 && res.data.data){
                  _this.task_render();
              }
          })
      },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reflash{
    color: #daa250;
    text-decoration: underline;
}


.reflash .icon{
    display: inline-block;
    width: 23px;
    height: 19px;
    margin: 0 10px;
    background-image: url(../images/icon-reflash.png);
    vertical-align: sub;
}



@media screen and (min-device-width: 1025px){
    .notice{
        font-size: 14px;
        color: #fdf0d5;
        text-align: center;
    }

    .reflash{
        display: inline-block;
        padding-left: 15px;
    }

    .reflash:hover{
        color: #f3bb69;
    }

    .reflash:hover .icon{
        background-image: url(../images/icon-reflash_hover.png);
    }

    .u-btn.rule_old{
        display: inline-block;
        vertical-align: middle;
        width: 31px;
        height: 32px;
        margin-left: 20px;
        background-image: url(../images/btn-rule_old.png);
    }

    .u-btn.rule_old:hover{
        background-image: url(../images/btn-rule_old_hover.png);
    }

    .task-list>ul{
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }

    .task-list>ul>li{
        position: relative;
        width: 312px;
        height: 354px;
        font-size: 14px;
        color: #5c483c;
        text-align: center;
        background-image: url(../images/bg-task-item.png);
    }

    .task-list li h6{
        padding-top: 22px;
        margin-bottom: 25px;
        font-size: 18px;
        font-weight: 700;
        color: #ffeec4;       
    }

    .task-list li>.task-content{
        padding: 0 40px;
    }

    .task-pro{
        width: 128px;
        height: 24px;
        line-height: 24px;
        margin: 12px auto 12px;
        background-image: url(../images/bg-task_cnt.png);
    }

    .task-pro b{
        padding-right: 10px;
        font-weight: 700;
        color: #963835;
    }

    .task-list .reward-list{
        display: flex;
        justify-content: space-between;
        margin: 0 18px;
    }

    .task-list .reward-list li{
        width: 33%;
    }

    .task-list .reward-list .item{
        width: 83px;
        height: 80px;
        margin: 0 auto;
        background-image: url(../images/bg-item.png);        
    }

    .task-list .u-btn.apply{
        position: absolute;
        bottom: 20px;
        left: 50%;
        width: 127px;
        height: 41px;
        margin: 15px auto 0;
        transform: translateX(-50%);
        background-image: url(../images/btn-apply_task.png);
    }

    .task-list .u-btn.apply:hover{
        background-image: url(../images/btn-apply_task_hover.png);
    }
}

@media screen and (max-device-width: 1024px){
    .notice{
        position: relative;
        font-size: 24px;
        color: #fdf0d5;
    }

    .notice span{
        display: inline-block;
        padding-right: 270px;
    }

    .notice .reflash{
        position: absolute;
        top: 22px;
        right: 0;   
    }

    .reflash .icon{
        width: 40px;
        height: 33px;
        background-image: url(../images/m/icon-reflash.png);          
    }

    .u-btn.rule_old{
        position: absolute;
        top: 0;
        left: 470px;
        width: 64px;
        height: 66px;
        margin-left: 20px;
        background-image: url(../images/m/btn-task-rule.png);
    }

    .task-list{
        margin-top: 40px;
    }

    .task-list>ul>li{
        position: relative;
        width: 673px;
        height: 446px;
        margin: 0 auto 15px;
        padding-top: 32px;
        padding-left: 80px;
        font-size: 24px;
        color: #5c483c;
        text-align: center;
        background-image: url(../images/m/bg-task-item.png);
        box-sizing: border-box;
    }

    .task-list li h6{
        position: absolute;
        left: 0;
        top: 0;
        width: 79px;
        height: 100%;
        font-size: 26px;
        font-weight: 700;
        color: #ffeec4;       
    }

    .task-list li h6 p{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 26px;
        line-height: 1;
        transform: translate(-50%,-50%);
    }

    .task-list li>.task-content{
        padding: 0 45px;
    }

    .task-pro{
        width: 256px;
        height: 48px;
        line-height: 48px;
        margin: 20px auto 10px;
        background-image: url(../images/m/bg-task.png);
    }

    .task-pro b{
        padding-right: 10px;
        font-weight: 700;
        color: #963835;
    }

    .task-list .reward-list{
        display: flex;
        justify-content: space-between;
        margin: 0 65px;
    }

    .task-list .reward-list li{
        width: 33%;
    }

    .task-list .reward-list .item{
        width: 124px;
        height: 124px;
        margin: 0 auto;
        background-image: url(../images/m/bg-item-2.png);        
    }

    .task-list .u-btn.apply{
        position: absolute;
        bottom: 20px;
        right: 196px;
        width: 218px;
        height: 65px;
        background-image: url(../images/m/btn-apply.png);
    }    

}

</style>



// WEBPACK FOOTER //
// src/components/task.invite.vue